import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorksProductivityNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].getWorksProductivityNorms,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}

function getBasedWorksProductivityNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].getBasedWorksProductivityNorms,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}

function getExtendedWorksProductivityNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].getExtendedWorksProductivityNorms,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}

function getWorksProductivityNorm(companyId, worksProductivityNormId) {
	return dataTransferWrap(ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].getWorksProductivityNorm, {
		urlParams: {
			companyId,
			worksProductivityNormId,
		},
	})
}

function createWorksProductivityNorm(companyId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].createWorksProductivityNorm,
		{
			urlParams: {
				companyId,
			},
			...data,
		}
	)
}

function putWorksProductivityNorm(companyId, worksProductivityNormId, data) {
	return dataTransferWrap(ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].putWorksProductivityNorm, {
		urlParams: {
			companyId,
			worksProductivityNormId,
		},
		...data,
	})
}

function patchWorksProductivityNorm(companyId, worksProductivityNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].patchWorksProductivityNorm,
		{
			urlParams: {
				companyId,
				worksProductivityNormId,
			},
			...data,
		}
	)
}

function deleteWorksProductivityNorm(companyId, worksProductivityNormId) {
	return dataTransferWrap(
		ModulesMap.WORKS_PRODUCTIVITY_NORMS,dtConfig[ModulesMap.WORKS_PRODUCTIVITY_NORMS].deleteWorksProductivityNorm,
		{
			urlParams: {
				companyId,
				worksProductivityNormId,
			},
		}
	)
}

export default {
	getWorksProductivityNorms,
	getBasedWorksProductivityNorms,
	getExtendedWorksProductivityNorms,
	getWorksProductivityNorm,
	createWorksProductivityNorm,
	putWorksProductivityNorm,
	patchWorksProductivityNorm,
	deleteWorksProductivityNorm,
}
